var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger btn-block",attrs:{"disabled":_vm.countChecked === 0 ? true : false},on:{"click":_vm.handleDeletes}},[_c('i',{staticClass:"fa fa-trash-alt"}),_vm._v(" Xóa\n")])}
var staticRenderFns = []

export { render, staticRenderFns }